import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { EmailDeliveryStatus } from '../../message/model/const/enums';
import { ReminderDeliveryMethod } from './const/enum';
import { InvoiceReminderGuarantor } from './invoice-reminder-guarantor';

export class InvoiceReminder extends ModelBase {
  constructor() {
    super();
    Object.defineProperties(this, {
      _createdDate: { enumerable: false, writable: true },
      _sentDate: { enumerable: false, writable: true },
      _invoiceDueDate: { enumerable: false, writable: true },
      _invoiceDefermentDate: { enumerable: false, writable: true },
    });
  }

  private _createdDate: Date;
  private _sentDate: Date;
  private _invoiceDueDate: LocalDate;
  private _invoiceDefermentDate: LocalDate;

  get createdDate(): Date {
    return this._createdDate;
  }
  set createdDate(value: Date) {
    this._createdDate = this.coerceDate(value);
  }

  get sentDate(): Date {
    return this._sentDate;
  }
  set sentDate(value: Date) {
    this._sentDate = this.coerceDate(value);
  }

  get invoiceDueDate(): LocalDate {
    return this._invoiceDueDate;
  }
  set invoiceDueDate(value: LocalDate) {
    this._invoiceDueDate = LocalDate.fromDate(value);
  }

  get invoiceDefermentDate(): LocalDate {
    return this._invoiceDefermentDate;
  }
  set invoiceDefermentDate(value: LocalDate) {
    this._invoiceDefermentDate = LocalDate.fromDate(value);
  }

  deliveryStatus: EmailDeliveryStatus;

  invoiceRecipient: string;
  companyNumberAndName: string;
  invoiceNumber: string;
  invoiceId: string;
  invoiceTotalAmount: Money;
  invoiceUnPaidAmount: Money;
  reminderDeliveryMethodText: string;
  emailDeliveryInfo: string;
  emailDeliveryStatusText: string;
  deliveryMethod: ReminderDeliveryMethod;
  deliveryStatusText: string;
  sendToGuarantor: boolean;
  guarantorReminders: InvoiceReminderGuarantor[];
  hasGuarantors: boolean;
  ocr: string;
}
